import { Typography } from "antd";
import { comma } from "../../../utils/util";
import { Image } from "antd";
import { 
  BACKEND_URL_MAIN,
 } from '../../../utils/util';
// const calTotalDiscount = (rec) => {
//   const total = Number(rec?.qty || 0) * Number(rec?.price || 0);
//   const discount = 1 - Number(rec?.discount || 0) / 100;

//   return total * discount;
// };

export const column = [
  {
    title: "Item",
    key: "index",
    align: "center",
    width: "6%",
    // onCell: () => ({
    //   style: {
    //     borderLeft: "1px solid var(---color--1)",
    //   },
    // }),
    // render: (_, record, idx) => <span key={record?.stcode}>{idx + 1}</span>,
    render: (_, record, idx) => (
      <Typography.Text className="tx-info">{idx + 1}</Typography.Text>
    ),
  },
  {
    title: "Product images",
    align: "center",
    key: "file_name",
    dataIndex: "file_name",
    width: 100,
    render: (im, rec) => 
      {
        const img = (!!rec.file_name ? `/uploads/` + rec.file_name : `/Logo-AI.png`
        );
        return <>
        <Image
      style={{ borderRadius: 10 }}
      preview={false}
      height={50}
      alt={`Image ${rec.file_name}`}
      src={`${BACKEND_URL_MAIN}` + img}
    />
    </>
    },
  },

  {
    title: "Product Code",
    align: "center",
    key: "stcode",
    dataIndex: "stcode",
    width: 100,
  },
  {
    title: "Brand Name",
    align: "center",
    width: 50,
    key: "brand_name",
    dataIndex: "brand_name",
  },
  {
    title: "Description",
    align: "center",
    children: [
      {
        title: "TH",
        dataIndex: "stname",
        key: "stname",
        width: 150,
        align: "center",
      },
      {
        title: "English",
        dataIndex: "stnameEN",
        key: "stnameEN",
        width: 150,
        align: "center",
      },
    ],
  },
  {
    title: "Quantity",
    align: "center",
    key: "qty",
    dataIndex: "qty",
    width: 50,
    onCell: () => ({
      style: {
        borderRight: "1px solid var(---color--1)",
      },
    }),
    render: (v) => (
      <Typography.Text className="tx-info">{comma(Number(v))}</Typography.Text>
    ),
  },
];
